/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'aboutPage',
	title: 'About Page',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Page Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'header',
			title: 'Header Section',
			type: 'object',
			fields: [
				{
					name: 'heading',
					title: 'Heading',
					type: 'string',
				},
				{
					name: 'subheading',
					title: 'Subheading',
					type: 'text',
				},
				{
					name: 'backgroundImage',
					title: 'Background Image',
					type: 'image',
					options: {
						hotspot: true,
					},
				},
			],
		},
		{
			name: 'introduction',
			title: 'Introduction',
			type: 'array',
			of: [
				{
					type: 'block',
					marks: {
						decorators: [
							{ title: 'Strong', value: 'strong' },
							{ title: 'Emphasis', value: 'em' },
						],
						annotations: [
							{
								name: 'color',
								title: 'Color',
								type: 'object',
								fields: [
									{
										name: 'value',
										title: 'Color',
										type: 'string',
										options: {
											list: [
												{ title: 'Yellow', value: 'yellow' },
												{ title: 'Black', value: 'black' },
											],
										},
									},
								],
							},
						],
					},
				},
			],
		},
		{
			name: 'founder',
			title: 'About Founder',
			type: 'object',
			fields: [
				{
					name: 'name',
					title: 'Name',
					type: 'string',
				},
				{
					name: 'role',
					title: 'Role',
					type: 'string',
				},
				{
					name: 'image',
					title: 'Image',
					type: 'image',
					options: {
						hotspot: true,
					},
				},
				{
					name: 'bio',
					title: 'Bio',
					type: 'array',
					of: [{ type: 'block' }],
				},
			],
		},
		{
			name: 'impactMap',
			title: 'Impact Map',
			type: 'object',
			fields: [
				{
					name: 'title',
					title: 'Section Title',
					type: 'string',
				},
				{
					name: 'subtitle',
					title: 'Section Subtitle',
					type: 'text',
				},
				{
					name: 'locations',
					title: 'Impact Locations',
					type: 'array',
					of: [
						{
							type: 'object',
							fields: [
								{
									name: 'country',
									title: 'Country',
									type: 'string',
								},
								{
									name: 'latitude',
									title: 'Latitude',
									type: 'number',
								},
								{
									name: 'longitude',
									title: 'Longitude',
									type: 'number',
								},
							],
						},
					],
				},
			],
		},
		{
			name: 'faq',
			title: 'FAQ Section',
			type: 'faqSection',
		},
	],
	preview: {
		select: {
			title: 'title',
		},
	},
};
